import React, { useCallback } from "react";
import { Bell } from "lucide-react";
import { EvaluationStatusFilter, IProjectEvaluatorData } from "../../../project";
interface EvaluatorCardProps {
    evaluator: IProjectEvaluatorData;
    onReminderClick: (evaluator: IProjectEvaluatorData) => void;
    activeTab: EvaluationStatusFilter;
    setActiveTab: (tab: EvaluationStatusFilter) => void
    index: number
}
const EvaluatorCard = React.memo<EvaluatorCardProps>(({ evaluator, onReminderClick, activeTab, setActiveTab, index }) => {
    const handleReminderClick = useCallback(() => {
        onReminderClick(evaluator);
    }, [evaluator, onReminderClick]);
    return (
        <div className="col-md-4">
            <div className="apple-card gestalt-group group border-0 shadow-sm rounded-5 p-5 w-100">
                <div className="d-flex align-items-start mb-3">
                    <div className="symbol symbol-35px symbol-circle" >
                        <span className="symbol-label text-inverse-primary fw-bolder overlaped-circle" style={{ background: index % 2 === 0 ? " 'linear-gradient(135deg, rgb(60, 114, 231) 0%, rgb(43, 77, 117) 100%'" : "gray" }}>{evaluator.initials}</span>
                    </div>
                    <div className="flex-grow-1">
                        <div className="ms-5">
                            <div className="mb-2">
                                <div className="fw-semibold fs-4 mb-0">{evaluator.full_name}</div>
                                <small className="text-gray-600">{evaluator.email}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex gap-3 mb-3">
                    <div className={`badge border border-2 border-primary ${activeTab === "all" ? "border border-primary active-gate" : ""} cursor-pointer rounded-4 flex-fill flex-column fs-6 py-3`} onClick={() => {
                        if (evaluator.assigned > 0) {
                            setActiveTab(EvaluationStatusFilter.all);
                            handleReminderClick();
                        }
                    }}>
                        <strong className="text-primary mb-1">{evaluator.assigned}</strong>
                        <div className="text-gray-700 fw-normal">Assigned</div>
                    </div>
                    <div className={`badge border border-2 border-success ${activeTab === "completed" ? "border border-success active-gate" : ""} cursor-pointer rounded-4 flex-fill flex-column fs-6 py-3`} onClick={() => {
                        if (evaluator.done > 0) {
                            setActiveTab(EvaluationStatusFilter.completed);
                            handleReminderClick();
                        }
                    }}>
                        <strong className="text-success mb-1">{evaluator.done}</strong>
                        <div className="text-gray-700 fw-normal">Completed</div>
                    </div>
                    <div className={`badge border border-2 border-warning ${activeTab === "pending" ? "g active-gate" : ""} cursor-pointer rounded-4 flex-fill flex-column fs-6 py-3`} onClick={() => {
                        if (evaluator.pending > 0) {
                            setActiveTab(EvaluationStatusFilter.pending);
                            handleReminderClick();
                        }
                    }}>
                        <strong className="text-warning mb-1">{evaluator.pending}</strong>
                        <div className="text-gray-700 fw-normal">Pending</div>
                    </div>
                    <div
                        className={`badge border border-2 border-danger ${activeTab === "overdue" ? " active-gate" : ""
                            } cursor-pointer rounded-4 flex-fill flex-column fs-6 py-3`}
                        onClick={() => {
                            if (evaluator.overdue > 0) {
                                setActiveTab(EvaluationStatusFilter.overdue);
                                handleReminderClick();
                            }
                        }}
                    >
                        <strong className="text-danger mb-1">{evaluator.overdue}</strong>
                        <div className="text-gray-700 fw-normal">Overdue</div>
                    </div>
                </div>
                <button className="btn btn-sm bg-white text-primary w-100" onClick={() => {
                    handleReminderClick()
                    setActiveTab(evaluator.overdue > 0 ? EvaluationStatusFilter.overdue : evaluator.pending > 0 ? EvaluationStatusFilter.pending : evaluator.done > 0 ? EvaluationStatusFilter.completed : EvaluationStatusFilter.all)
                }}>
                    <Bell className="me-1" size={14} /> Send Reminder
                </button>
            </div>
        </div >
    )
})
export default EvaluatorCard;